import { Component, ElementRef, EventEmitter, HostListener, Input, Optional, Output } from '@angular/core';
import { Attachment } from '../../../reservation.model';
import { ReservationMessageDialogComponent } from '../reservation-message-dialog.component';
import { MatDialogRef } from '@angular/material/dialog';
import { DownloadFileService } from '../../../../common/download-file.service';
import { By } from '@angular/platform-browser';

@Component({
	selector: 'app-reservation-message-gallery',
	templateUrl: './reservation-message-gallery.component.html',
	styleUrls: ['./reservation-message-gallery.component.scss'],
})
export class ReservationMessageGalleryComponent {
	galleryData: Attachment[] = [];
	@Input() attachmentsList: Attachment[][] = [];
	@Output() downloadClicked: EventEmitter<{
		messageIndex: number;
		attachmentIndex: number;
	}> = new EventEmitter<{ messageIndex: number; attachmentIndex: number }>();
	selectedImage: Attachment;

	constructor(
		@Optional()
		private readonly dialogRef: MatDialogRef<ReservationMessageDialogComponent>,
		public downloadService: DownloadFileService,
	) {}

	@HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
		if (this.galleryData.length) {
			switch (event.code) {
				case 'ArrowRight':
				case 'KeyD':
					this.nextImage();
					break;
				case 'ArrowLeft':
				case 'KeyA':
					this.previousImage();
					break;
				case 'Escape':
					this.closeGallery();
					break;
				default:
					break;
			}
		}
	}

	closeGallery() {
		this.galleryData = [];
		this.dialogRef.disableClose = false;
	}

	openGallery(attachmentList: Attachment[], index: number) {
		this.galleryData = attachmentList;
		this.selectedImage = this.galleryData[index];
		this.dialogRef.disableClose = true;
	}

	protected nextImage() {
		const currentIndex = this.galleryData.indexOf(this.selectedImage);
		this.selectedImage = this.galleryData[currentIndex + 1]
			? this.galleryData[currentIndex + 1]
			: (this.selectedImage = this.galleryData[0]);
	}

	protected previousImage() {
		const currentIndex = this.galleryData.indexOf(this.selectedImage);
		this.selectedImage = this.galleryData[currentIndex - 1]
			? this.galleryData[currentIndex - 1]
			: (this.selectedImage = this.galleryData[this.galleryData.length - 1]);
	}

	protected selectImage(i: number) {
		this.selectedImage = this.galleryData[i];
	}
}
